module.exports = __webpack_public_path__ + "img/bgtop.6e51c17d.jpg";